import React, { Component } from "react";
import t from "babel-plugin-yate/macro";
import { connect } from "react-redux";
import * as Sentry from "@sentry/browser";

import Button from "./Button";

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      eventId: null
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { currentUser } = this.props;

    Sentry.withScope(scope => {
      if (currentUser && currentUser.email) {
        scope.setUser({
          id: currentUser.id,
          email: currentUser.email,
          username: currentUser.username,
          phone: currentUser.phone,
          name: `${currentUser.first_name} ${currentUser.last_name}`
        });
      }

      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  reportError = () => {
    const { currentUser } = this.props;
    const { eventId } = this.state;

    const errorReportDialogOptions = {
      eventId
    };

    if (currentUser && currentUser.email) {
      errorReportDialogOptions.user = {
        email: currentUser.email,
        name: `${currentUser.first_name} ${currentUser.last_name}`
      };
    }

    Sentry.showReportDialog(errorReportDialogOptions);
  };

  reloadPage = () => window.location.reload();

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div className="flex h-screen items-center justify-center text-center">
          <div className="-mt-32">
            <div className="text-36 pb-1">
              {t`An unknown error has occured`}. 🧐
            </div>

            <div className="pb-4 text-16">
              {t`You can help us by reporting what happened or you can reload the page.`}
            </div>

            <div className="pt-4">
              <span className="mr-8">
                <Button
                  title={t`Report`}
                  color="blue"
                  border={false}
                  onClick={this.reportError}
                />
              </span>

              <Button
                title={t`Reload page`}
                color="red"
                border={false}
                onClick={this.reloadPage}
              />
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default connect(state => ({
  currentUser: state.auth.user
}))(AppErrorBoundary);
